const Project_Data = [
    {
        id:1,
        cat:'FP',
        src:'images/block-4.svg',
        text:'Blockchain DApp',
        path:'/services',
        subtitle:"Create a decentralized freelancing application using Blockchain that can make freelancing faster without having any third authority to control the system ",
        p1 : "Solidity",
        p2 :"Ethereum",
        p3 :"IPFS",
        p4 :"MetaMask",
    },
    {
        id:2,
        cat:'FP',
        src:'images/bid-2.svg',
        text:'BidOps ',
        path:'/services',
        subtitle:"The project was introduced by a client in CalPERS. The objective of the project is to develop an automated system which will ease the bid submission process.",
        p1 : "Laravel",
        p2 :"PHP",
        p3 :"MySQL",
        p4 :"Javascript",
    },
    {
        id:3,
        cat:'FP',
        src:'images/shop.svg',
        text:'Smart Buy',
        path:'/services',
        subtitle:"The Idea of our project is to create a web application where user can analyze product prices that are present on multiple e-commerce websites. ",
        p1 : "Scraping",
        p2 :"Mongodb",
        p3 :"Django",
        p4 :"Python",
    },




]

const ML_Data = [
    {
        id:1,
        cat:'ML',
        src:'images/cancer.svg',
        text:'CancerNet',
        path:'/services',
        subtitle:"Breast cancer detection web application With payment integration. Accurately identifying breast cancer is an important clinical task, and automated methods can be used to save time and reduce error.",
        p1 : "Solidity",
        p2 :"Ethereum Blockchain",
        p3 :"IPFS",
        p4 :"MetaMask",
    },
    {
        id:2,
        cat:'ML',
        src:'images/house.svg',
        text:'House Price Prediction',
        path:'/services',
        subtitle:"House market plays an important role in shaping the economy.  In this project we propose finding an estimation using categorical, numerical as well as visual (images) dataset.",
        p1 : "Laravel",
        p2 :"PHP",
        p3 :"MySQL",
        p4 :"Javascript",
    },

    {
        id:3,
        cat:'ML',
        src:'images/image.svg',
        text:'Image Classification',
        path:'/services',
        subtitle:" Build a User Interface for Image Classification using PreTrainedModel MobileNet. We are using Tensorflow.js library to load a model and make prediction using JavaScript programming.",
        p1 : "Scraping",
        p2 :"Mongodb",
        p3 :"Django",
        p4 :"Python",
    },

]


export{Project_Data,ML_Data}
